/**
 * Timeline Alt – prev/next arrows move timeline bar and fade content (year, text, images).
 */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('timeline-alt')) return;

  class TimelineAlt extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.dots = [];
      this.prevBtn = null;
      this.nextBtn = null;
      this.barDots = null;
      this.barTrack = null;
      this.index = 0;
      this.count = 0;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.timeline-alt__slide'));
      this.dots = Array.from(this.querySelectorAll('.timeline-alt__dot'));
      this.prevBtn = this.querySelector('.timeline-alt__nav-btn--prev');
      this.nextBtn = this.querySelector('.timeline-alt__nav-btn--next');
      this.barDots = this.querySelector('.timeline-alt__bar-dots');
      this.barTrack = this.querySelector('.timeline-alt__bar-track');
      this.barLine = this.querySelector('.timeline-alt__bar-line');
      this.count = this.slides.length;

      if (this.count === 0) return;

      this.prevBtn?.addEventListener('click', () => this.go(-1));
      this.nextBtn?.addEventListener('click', () => this.go(1));

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.setIndex(i));
      });

      this.setIndex(0);
      if (this.barTrack && this.barDots) {
        window.addEventListener('resize', () => this.updateBarPosition());
      }
    }

    go(delta) {
      const next = this.index + delta;
      this.setIndex(Math.max(0, Math.min(next, this.count - 1)));
    }

    setIndex(i) {
      if (i === this.index && this.count > 0) return;
      this.index = i;

      this.slides.forEach((slide, idx) => {
        slide.classList.toggle('is-active', idx === i);
      });

      this.dots.forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === i);
        dot.setAttribute('aria-current', idx === i ? 'true' : 'false');
      });

      this.updateBarPosition();
    }

    updateBarPosition() {
      if (!this.barTrack || !this.barDots || this.count <= 1) return;

      const trackWidth = this.barTrack.offsetWidth;
      const dotsWidth = this.barDots.scrollWidth;
      const maxScroll = Math.max(0, dotsWidth - trackWidth);

      if (maxScroll <= 0) {
        this.barDots.style.transform = 'translateX(0)';
        if (this.barLine) {
          this.barLine.style.width = '';
          this.barLine.style.transform = 'translateY(-50%)';
        }
        return;
      }

      const segment = maxScroll / Math.max(1, this.count - 1);
      const offset = -this.index * segment;
      this.barDots.style.transform = 'translateX(' + offset + 'px)';

      if (this.barLine) {
        this.barLine.style.width = dotsWidth + 'px';
        this.barLine.style.transform = 'translateY(-50%) translateX(' + offset + 'px)';
      }
    }
  }

  customElements.define('timeline-alt', TimelineAlt);
})();
